import 'animate.css/animate.compat.css'

import { Box, createTheme, css, ThemeProvider } from '@mui/material'

import { BackedBy } from './components/BackedBy'
import { Background } from './components/Background'
import { Blog } from './components/Blog'
import { HumaDifference } from './components/HumaDifference'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { HeroText } from './components/HeroText'
import { JoinTheCommunity } from './components/JoinTheCommunity'
import { GlobalMoneyMovement } from './components/GlobalMoneyMovement'
import { Payfi } from './components/Payfi'
import { ProtocolStats } from './components/ProtocolStats'
import { Subscription } from './components/Subscription'
import { useMQ } from './hooks/useMQ'
import { Huma2 } from './components/Huma2'
import { Video } from './components/Video'
export const humaTheme = createTheme({
  palette: {
    primary: {
      main: '#aba8a8',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#fff',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          color: '#000',
          textTransform: 'none',
          background: 'linear-gradient(to right, #fff 0%, #6A6A6A 100%)',
          transition: 'background 0.3s ease-in-out',
          '&:hover': {
            background: 'linear-gradient(to right, #fff 61%, #6A6A6A 100%)',
          },
        },
        outlined: {
          textTransform: 'none',
          color: '#CECECE',
          border: '1px solid #CECECE',
          '&:hover': {
            color: '#fff',
            border: '1px solid #CECECE',
          },
          '&.Mui-disabled': {
            borderColor: '#686868',
            backgroundClip: 'unset',
            textFillColor: 'unset',
            color: '#686868',
            background: 'none',
          },
        },
        root: {
          fontFamily: 'Red-Hat-Display',
          fontSize: '15px',
          borderRadius: '32px',
        },
      },
    },
  },
})

function App() {
  const { isXsSize, isBelow1200 } = useMQ()

  const styles = {
    appWrapper: css`
      min-height: 100vh;
      position: relative;
      overflow-x: hidden;
      overflow-y: hidden;
      padding-left: ${isBelow1200 ? '16px' : '0'};
      padding-right: ${isBelow1200 ? '16px' : '0'};
    `,
    bgLeft: css`
      position: absolute;
      z-index: 1;
      width: 70%;
      bottom: ${isXsSize ? '600px' : '440px'};
      left: 0;
    `,
    bgMiddle: css`
      position: absolute;
      z-index: 1;
      width: 70%;
      bottom: ${isXsSize ? '600px' : '440px'};
      left: 15%;
    `,
    bgRight: css`
      position: absolute;
      z-index: 1;
      width: 70%;
      bottom: ${isXsSize ? '600px' : '440px'};
      right: 0;
    `,
  }

  return (
    <ThemeProvider theme={humaTheme}>
      <Background />
      <Box css={styles.appWrapper}>
        <Header />
        <HeroText />
        <Video />
        <Huma2 />
        <ProtocolStats />
        <Payfi />
        <GlobalMoneyMovement />
        <HumaDifference />
        <BackedBy />
        <JoinTheCommunity />
        <Blog />
        <Subscription />
        <Footer />
      </Box>
    </ThemeProvider>
  )
}

export default App
